var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemBenefit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5 101.689C79.2065 101.689 101.864 79.0316 101.864 51.3252C101.864 23.5746 79.2065 0.960938 51.5 0.960938C23.7494 0.960938 1.13574 23.5761 1.13574 51.3252C1.13422 79.0316 23.7494 101.689 51.5 101.689Z",
    fill: "#393E45",
    stroke: "black",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0186 29.7023C42.3054 29.8743 61.6411 28.9684 61.8999 29.7023C62.1161 30.4361 61.8573 33.8891 61.2087 34.32C59.569 35.4421 58.0587 36.5642 56.9792 37.5995C58.3175 40.1451 60.3028 42.9511 62.4602 45.7996C66.6897 51.5395 78.7738 60.8191 70.6604 71.0472C68.1574 74.1547 64.7485 75.837 60.7337 75.837H41.1407C37.17 75.837 33.717 74.1531 31.2581 71.0472C23.1021 60.8191 35.2288 51.5395 39.4583 45.7996C41.5731 42.9511 43.5584 40.1466 44.8967 37.5995C43.8172 36.5642 42.3069 35.4421 40.6671 34.32C39.8465 33.7582 39.5877 29.7023 40.0186 29.7023Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4602 66.5156V70.6599H35.3587V74.8026H32.9852H25.1732H22.4982V70.6599H20.5981V66.5156H33.4602Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1576 62.3301H81.0623V66.5154H82.4859V70.6597H80.5873V74.8024H78.0417H73.9842H70.2298H67.6826V70.6597H69.5827V66.5154H68.1576V62.3301Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8967 34.9248H47.9173H50.9379H53.9586H56.9792C58.3175 37.4704 60.3028 40.2764 62.4602 43.125C66.6897 48.8648 78.7738 58.1444 70.6604 68.3726C68.1574 71.5226 64.7485 73.1624 60.7337 73.1624C54.2174 73.1624 47.6996 73.1624 41.1407 73.1624C37.17 73.1624 33.717 71.5226 31.2581 68.3726C23.1021 58.1444 35.2288 48.8648 39.4583 43.125C41.5731 40.2764 43.5584 37.4704 44.8967 34.9248Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4524 65.9163H60.2222V59.3581H53.4524V57.1951H55.7544V55.0322H57.9871V52.8022H60.2198V48.474H55.752V50.6369H53.45V52.7999H51.2173V55.0299H48.9846V48.4717H42.2148V55.0299H48.9846V57.1928H46.6827V59.3558H44.45V61.5187H42.2172V65.9117H46.685V63.7487H48.987V61.5187H51.2197V59.3558L53.4524 59.3581V65.9163ZM55.7544 61.5233H57.9871V63.7534H55.7544V61.5233ZM44.45 50.6392H46.6827V52.8022H44.45V50.6392Z",
    fill: "#26894F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4524 59.3581H60.2222V65.9163H53.4524V59.3581ZM53.4524 59.3581V57.1951H55.7544V55.0322H57.9871V52.8022H60.2198V48.474H55.752V50.6369H53.45V52.7999H51.2173V55.0299H48.9846M53.4524 59.3581L51.2197 59.3558V61.5187H48.987V63.7487H46.685V65.9117H42.2172V61.5187H44.45V59.3558H46.6827V57.1928H48.9846V55.0299M48.9846 55.0299V48.4717H42.2148V55.0299H48.9846ZM55.7544 61.5233H57.9871V63.7534H55.7544V61.5233ZM44.45 50.6392H46.6827V52.8022H44.45V50.6392Z",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8967 34.9262H56.9807C58.0601 33.8909 59.5705 32.7688 61.2102 31.6467C61.8573 31.2158 62.1161 30.4378 61.9014 29.704C61.6426 28.9701 60.9955 28.4951 60.2175 28.4951H41.6598C40.8833 28.4951 40.2363 28.9701 40.0201 29.704C39.7613 30.4378 40.0201 31.2143 40.6671 31.6467C42.3069 32.7672 43.8172 33.8893 44.8967 34.9262Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3433 37.6006H51.8449",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8208 37.6006H58.5753",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5873 68.9336H67.6826V73.1205H80.5873V68.9336Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4882 64.79H69.5835V68.9328H82.4882V64.79Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0639 60.6455H68.1592V64.7882H81.0639V60.6455Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3586 68.9336H22.498V73.1205H35.3586V68.9336Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4587 64.79H20.5981V68.9328H33.4587V64.79Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.042 73.1195V70.2725",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.228 73.1195V70.2725",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9839 73.1195V70.2725",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1118 68.9319V66.126",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0112 68.9319V66.126",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.687 64.7903V61.9844",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8765 64.7903V61.9844",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9839 73.1195V70.2725",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1709 73.1195V70.2725",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2446 68.9319V66.126",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1006 68.9319V66.126",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1396 73.1631V75.8381",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3307 14.5107L70.7042 22.2359L78.3852 21.9344V24.1786L71.5675 26.5522L68.3307 34.7082L65.0938 26.5522L58.2319 24.1786V21.9344L65.9571 22.2359L68.3307 14.5107Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0563 34.752L30.999 41.0962L37.3432 40.3624L36.9109 42.6065L31.8622 44.5492L29.0563 51.3243L26.2518 44.5492L21.2459 42.6065L20.8135 40.3624L27.1151 41.0962L29.0563 34.752Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3307 11.8789L70.7042 19.5599L78.3852 21.935L70.7042 24.3086L68.3307 31.1705L65.9571 24.3086L58.2319 21.935L65.9571 19.5599L68.3307 11.8789Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0563 32.0771L30.999 38.4214L37.3432 40.3626L30.999 42.3053L29.0563 47.7863L27.1151 42.3053L20.8135 40.3626L27.1151 38.4214L29.0563 32.0771Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0918 26.5523V24.1787",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5239 26.6386V24.0488",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8633 44.5503V42.1768",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0532 50.9803V47.7861",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.332 34.7099V30.998",
    stroke: "#171819",
    strokeWidth: 0.776779,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemBenefit2);
export default __webpack_public_path__ + "static/media/redeem-benefit-2.37ea9b9ff9bb813bba8ef1bb8c31520f.svg";
export { ForwardRef as ReactComponent };